import { Link } from 'react-router-dom';
import { GraduationCap, Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white py-16 md:py-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-[#002FA7] rounded-sm flex items-center justify-center">
                <GraduationCap className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-black tracking-tight">RIKIRTUTOR</span>
            </Link>
            <p className="text-[#9CA3AF] leading-relaxed max-w-md">
              Expert tutoring services for GED preparation, SAT preparation, and all major college courses. 
              Unlock your potential with personalized learning.
            </p>
            <div className="flex flex-col gap-4 mt-6">
              <a href="mailto:acerikir1@gmail.com" className="flex items-center gap-2 text-[#9CA3AF] hover:text-white transition-colors">
                <Mail className="w-4 h-4" />
                <span className="text-sm">acerikir1@gmail.com</span>
              </a>
              <div className="flex items-start gap-2 text-[#9CA3AF]">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">215 East Bay St, Ste 201k #3579<br/>Charleston, SC 29401</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-sm tracking-wide mb-4">PROGRAMS</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/courses?category=GED" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
                  GED Preparation
                </Link>
              </li>
              <li>
                <Link to="/courses?category=SAT" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
                  SAT Preparation
                </Link>
              </li>
              <li>
                <Link to="/courses?category=College" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
                  College Courses
                </Link>
              </li>
              <li>
                <Link to="/tutors" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
                  Find a Tutor
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-sm tracking-wide mb-4">COMPANY</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/tutors" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
                  Our Tutors
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#9CA3AF] text-sm">
            © {new Date().getFullYear()} RikirTutor. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-[#9CA3AF] hover:text-white transition-colors text-sm">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
